import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Sticky, StickyContainer } from 'react-sticky';
import { Tabs, Collapse, Drawer, Pagination, Button, Checkbox } from 'antd';
import { useGarantia, useCondiciones } from '../../../hooks/Front/servicioTecnico/useServicios';

import EmptyData from '../mercadoPublico/emptyData';
import mapaIMG from '../../../img/servicioTecnico/mapa.svg';
import proteccionIMG from '../../../img/servicioTecnico/proteger.svg';
import iconGarantia from '../../../img/servicioTecnico/icono_garantia.svg';
import iconoFiltrar from '../../../img/icon_filtrar.svg';
import useWindowDimensions from '../../../hooks/Front/windowDimentions/useDimentions';


import './garantia.css'
import { useCategorias } from '../../../hooks/Front/outlet/useOutlet';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const Garantia = () => {
    const { width } = useWindowDimensions();

    const [categorias] = useCategorias();
    const [categoria, setCategoria] = useState("0");
    
    const [vehiculos, error] = useGarantia(categoria);
    const [condiciones] = useCondiciones();

    if (error === true) window.location.reload();

    const handleChangeCategoria = (key) => {
        setCategoria(key);
    }

    let margen = width <= 767 ? "51px" : width <= 991 ? "110px" : "118px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-70}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 1, background: 'white', height: "80px", top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );
    return (
        <>
            <Row>
                <Col className="px-0">
                    <StickyContainer>
                        <Tabs activeKey={categoria} className="mt-1 mt-md-4 tab-hyundai" centered onChange={handleChangeCategoria} renderTabBar={renderTabBar}>
                            <TabPane tab={<Title title="Todos" />} key="0">
                                <Row >
                                    <Col xs={12} sm={12} md={5} lg={4} xl={3} className="px-0 bg-white">
                                        <ProductosEncontrados lista={vehiculos} />
                                        <Filtro categoria={categoria} setCategoria={setCategoria} categorias={categorias} />
                                    </Col>
                                    <Col xs={12} md={7} lg={8} xl={9} className="border-tab-st">
                                        <Container fluid className="px-1 border-paginador">
                                            <div className="pr-4 pt-3 justify-content-end d-none d-md-flex bg-white">
                                                <Pagination defaultCurrent={1} total={5} className="paginador-hyundai" />
                                            </div>
                                        </Container>
                                        {vehiculos && vehiculos.length > 0 ?
                                            vehiculos.map((categoria, i) => <Seccion key={i} seccion={categoria} />) :
                                            <EmptyData />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>                            
                            {categorias && categorias.length > 0 && categorias.map((item) => 
                                <TabPane tab={<Title title={item.Nombre} />} key={item.idCategoria}>
                                    <Row >
                                        <Col xs={12} sm={12} md={5} lg={4} xl={3} className="px-0 bg-white">
                                            <ProductosEncontrados lista={vehiculos} />
                                            <Filtro categoria={categoria} setCategoria={setCategoria} categorias={categorias} />
                                        </Col>
                                        <Col xs={12} md={7} lg={8} xl={9} className="border-tab-st">
                                            <Container fluid className="px-1 border-paginador">
                                                <div className="pr-4 pt-3 justify-content-end d-none d-md-flex bg-white">
                                                    <Pagination defaultCurrent={1} total={5} className="paginador-hyundai" />
                                                </div>
                                            </Container>
                                            {vehiculos && vehiculos.length > 0 ?
                                                vehiculos.map((categoria, i) => <Seccion key={i} seccion={categoria} />) :
                                                <EmptyData />
                                            }
                                        </Col>
                                    </Row>
                                </TabPane>
                            )}    
                            {/* <TabPane tab={<Title title="Comerciales Livianos Clase B" />} key="2">
                                <Row >
                                    <Col xs={12} sm={12} md={5} lg={4} xl={3} className="px-0 bg-white">
                                        <ProductosEncontrados lista={vehiculos} />
                                        <Filtro categoria={categoria} setCategoria={setCategoria} />
                                    </Col>
                                    <Col xs={12} md={7} lg={8} xl={9} className="border-tab-st">
                                        <Container fluid className="px-1 border-paginador">
                                            <div className="pr-4 pt-3 justify-content-end d-none d-md-flex bg-white">
                                                <Pagination defaultCurrent={1} total={5} className="paginador-hyundai" />
                                            </div>
                                        </Container>
                                        {vehiculos && vehiculos.length > 0 ?
                                            vehiculos.map((categoria, i) => <Seccion key={i} seccion={categoria} />) :
                                            <EmptyData />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tab={<Title title="Camiones" />} key="3">
                                <Row >
                                    <Col xs={12} sm={12} md={5} lg={4} xl={3} className="px-0 bg-white">
                                        <ProductosEncontrados lista={vehiculos} />
                                        <Filtro categoria={categoria} setCategoria={setCategoria} />
                                    </Col>
                                    <Col xs={12} md={7} lg={8} xl={9} className="border-tab-st">
                                        <Container fluid className="px-1 border-paginador">
                                            <div className="pr-4 pt-3 justify-content-end d-none d-md-flex bg-white">
                                                <Pagination defaultCurrent={1} total={5} className="paginador-hyundai" />
                                            </div>
                                        </Container>
                                        {vehiculos && vehiculos.length > 0 ?
                                            vehiculos.map((categoria, i) => <Seccion key={i} seccion={categoria} />) :
                                            <EmptyData />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tab={<Title title="Buses y Minibuses" />} key="4">
                                <Row >
                                    <Col xs={12} sm={12} md={5} lg={4} xl={3} className="px-0 bg-white">
                                        <ProductosEncontrados lista={vehiculos} />
                                        <Filtro categoria={categoria} setCategoria={setCategoria} />
                                    </Col>
                                    <Col xs={12} md={7} lg={8} xl={9} className="border-tab-st">
                                        <Container fluid className="px-1 border-paginador">
                                            <div className="pr-4 pt-3 justify-content-end d-none d-md-flex bg-white">
                                                <Pagination defaultCurrent={1} total={5} className="paginador-hyundai" />
                                            </div>
                                        </Container>
                                        {vehiculos && vehiculos.length > 0 ?
                                            vehiculos.map((categoria, i) => <Seccion key={i} seccion={categoria} />) :
                                            <EmptyData />
                                        }
                                    </Col>
                                </Row>
                            </TabPane> */}
                        </Tabs>
                    </StickyContainer>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className="text-center mt-md-5">
                    <h4 className="bold-title-hyundai d-none d-md-block mb-5">Condiciones para mantener vigente tu garantía</h4>
                    <p className="bold-title-hyundai d-md-none my-4 f-responsive">Condiciones para mantener vigente tu garantía</p>
                </Col>
            </Row>
            <Row className="bg-condiciones mb-condiciones">
                <Col xs={12} md={11} lg={10} xl={8} className="mx-auto my-1">
                    <Row>
                        {
                            condiciones && condiciones.length > 0 ?
                                condiciones.map((condicion, i) => <Condicion key={i} item={condicion} />)
                                : ''
                        }
                    </Row>
                </Col>
            </Row>
        </>
    );
};

const Title = ({ title }) => (
    <>
        <h5 className="bold-title-hyundai px-md-5 mb-3 d-none d-md-block">{title}</h5>
        <h6 className="bold-title-hyundai font-title-mobile mb-1 d-md-none text-center">{title === "Comerciales Livianos Clase B" ? <span>Comerciales<br />Livianos Clase B</span> : title === "Buses y Minibuses" ? <span>Buses y<br />Minibuses</span> : title}</h6>
    </>
)

const Filtro = ({ categoria, setCategoria, categorias }) => {
    
    const [visible, setVisible] = useState(false);    
    const [linea, setLinea] = useState(undefined);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    const handleChangeCategoria = (value) => {
        let valor = value[value.length - 1] === undefined ? undefined : value[value.length - 1];

        setCategoria(valor === undefined ? "0" : valor.toString());
        // setLinea(valor)
    }
    
    useEffect(() => {
        setLinea(Number(categoria) ? Number(categoria) : undefined)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoria])

    return (
        <>
            <div className="d-none d-md-block">
                <Collapse defaultActiveKey={['linea']} className="bg-white" bordered={false}>
                    <Panel className="px-3 mt-3" header={<h5 className="bold-title-hyundai f-responsive-14">Linea de vehículos</h5>} key="linea">
                        <Checkbox.Group className="mb-3" onChange={handleChangeCategoria} value={[linea]}>
                            {categorias && categorias.length > 0 &&
                                categorias.map((categoria, i) =>
                                    <Row key={i}>
                                        <Col>
                                            <Checkbox value={categoria.idCategoria} className="parrafo-hyundai font-size-filtro f-responsive">{categoria.Nombre}</Checkbox>
                                        </Col>
                                    </Row>
                                )
                            }
                            {/* <Row>
                                <Col>
                                    <Checkbox value="2" className="parrafo-hyundai font-size-filtro f-responsive">Comerciales Livianos Clase B</Checkbox>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Checkbox value="3" className="parrafo-hyundai font-size-filtro f-responsive">Camiones</Checkbox>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Checkbox value="4" className="parrafo-hyundai font-size-filtro f-responsive">Buses y Minibuses</Checkbox>
                                </Col>
                            </Row> */}
                        </Checkbox.Group>
                    </Panel>
                </Collapse>
            </div>
            <div className="d-md-none">
                <Row className="button-mobile-of">
                    {/* <Col className="text-center px-0">
                        <Button variant="outline-light" className="mobile-buttons-outlet bold-title-hyundai border-bottom-v border-right-v h-100 w-100 f-responsive py-3">
                        <img src={iconoOrdenar} className="pr-2" alt="Ordenar" />Ordenar por</Button>
                    </Col> */}
                    <Col className="text-center px-0">
                        <Button variant="outline-light" onClick={showDrawer} className=" mobile-buttons-outlet bold-title-hyundai border-bottom-v h-100 w-100 f-responsive py-3">
                            <img src={iconoFiltrar} className="pr-2" alt="Filtrar" />Filtrar</Button>
                    </Col>
                </Row>
                <Drawer
                    className="drawer-mobile-garantia"
                    title="Filtrar"
                    closable={true}
                    onClose={onClose}
                    visible={visible}
                    placement="left"
                    key="left"
                    zIndex={1030}
                >
                    <Collapse bordered={false} className="bg-white" defaultActiveKey={['linea']}>
                        <Panel className="mt-1 mt-md-3" header={<h5 className="bold-title-hyundai f-responsive mt-1 mt-md-0">Linea de vehículos</h5>} key="linea">
                            <Checkbox.Group onChange={handleChangeCategoria} value={categoria}>                                
                                {categorias && categorias.length > 0 &&
                                    categorias.map((categoria, i) =>
                                        <Row key={i}>
                                            <Col>
                                                <Checkbox value={categoria.idCategoria} className="parrafo-hyundai outlet-normal f-responsive">{categoria.Nombre}</Checkbox>
                                            </Col>
                                        </Row>
                                    )
                                }
                                {/* <Row>
                                    <Col>
                                        <Checkbox value="2" className="parrafo-hyundai outlet-normal f-responsive">Comerciales Livianos Clase B</Checkbox>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Checkbox value="3" className="parrafo-hyundai outlet-normal f-responsive">Camiones</Checkbox>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Checkbox value="4" className="parrafo-hyundai outlet-normal f-responsive">Buses y Minibuses</Checkbox>
                                    </Col>
                                </Row> */}
                            </Checkbox.Group>
                        </Panel>
                    </Collapse>
                </Drawer>
            </div>
        </>
    )
};


const Condicion = ({ item }) => {
    return (
        <Col xs={12} md={4} className="mx-auto text-center">
            <img src={item.Valor} alt="mantencion-hyundai" className="img-fluid mt-4 icon-mantencion" />
            <h5 className="bold-title-hyundai color-commercial my-4 f-responsive-10">
                {item.Descripcion}
            </h5>
        </Col>
    )
}

const Seccion = ({ seccion }) => {

    if (!seccion || !seccion.vehiculos || seccion.vehiculos.length < 1) return null;

    return (
        <>
            <Row >
                <Col className="border-title px-1" xs={12}>
                    <Container fluid className="bg-white">
                        <Row>
                            <Col className="my-3 my-md-4">
                                <h5 className="bold-title-hyundai ml-0 ml-md-3 mb-0 font-title-mobile">{seccion.categoria}</h5>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className="border-seccion-mp">
                {seccion.vehiculos && seccion.vehiculos.length > 0 &&
                    seccion.vehiculos.map((vehiculo, i) => <Tarjeta vehiculo={vehiculo} key={i} />)
                }
            </Row>
        </>
    );
};

const Tarjeta = ({ vehiculo }) => {

    if (!vehiculo) return null;

    return (
        <>
            <Col className="pl-1 pr-0 pl-0 py-1 border-tarjeta-mp" xs={12} md={12} lg={12} xl={6} >
                <Container className="bg-white" fluid>
                    <Row>
                        <Col xs={4} xl={5} className="my-auto">
                            <img src={vehiculo.Imagen} alt={vehiculo.Nombre} className="img-fluid" />
                        </Col>
                        <Col xs={8} xl={7} className="my-3 mb-md-3 mt-md-4">
                            <Row>
                                <Col xs={12}>
                                    <h5 className="bold-title-hyundai mb-0 f-responsive-14">{vehiculo.Nombre}</h5>
                                    <p className="parrafo-hyundai f-responsive">{vehiculo.Version}</p>
                                </Col>
                            </Row>
                            {vehiculo.Descripcion && 
                            <>
                            <hr className="mt-0 mt-md-2 mb-0 mb-md-1" />
                            <Row>
                                <Col xs="auto" className="pr-0">
                                    <img src={iconGarantia} alt="garantia" className="img-fluid" width="40px" />
                                </Col>
                                <Col className="my-auto pl-0">
                                    <p className="parrafo-hyundai mb-0 f-responsive-10 d-none d-md-block">Garantia: {vehiculo.Descripcion.replace('<br/>', ' ').toLowerCase()}.*</p>
                                    <p className="parrafo-hyundai mb-0 f-responsive-10 d-block d-md-none">Garantia:<br />{vehiculo.Descripcion.replace('<br/>', ' ').toLowerCase()}.*</p>
                                </Col>
                            </Row>
                            <hr className="mb-2 mb-md-4 mt-0 mt-md-1" />
                            </>
                            }
                            <Row>
                                <Col xs={12}>
                                    <a href={vehiculo.PautaMantencion} target="_blank" rel="noopener noreferrer">
                                        <Button className="btn-primario font-btn ">
                                            Pauta mantenimiento
                                        </Button>
                                    </a>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </Col>
        </>

    )
}

const ProductosEncontrados = ({ lista }) => {

    const [productosEncontrados, setProductos] = useState(undefined)

    useEffect(() => {
        if (lista) {
            const sumarTodo = (array) => {
                let i = 0;

                array.map(item => i += item.vehiculos.length);
                setProductos(i);
            }
            sumarTodo(lista);
        }

    }, [lista])
    let sinProductos = !productosEncontrados ? true : productosEncontrados < 1 ? true : false
    return (
        <Container className="border-productosc mb-1 d-none d-md-block" fluid>
            <Row>
                <Col className="my-3 pt-3" xs={12}>
                    <h5 className="bold-title-hyundai ml-4">Vehículos</h5>
                    {productosEncontrados !== undefined &&
                        <>
                            {sinProductos === true ?
                                <p className="parrafo-hyundai ml-4 p-sos">No se encontraron productos.</p>
                                :
                                <p className="parrafo-hyundai ml-4 p-sos">{productosEncontrados} productos encontrados</p>
                            }
                        </>
                    }


                </Col>
            </Row>
        </Container>
    )
};
export default Garantia;